export default "__VITE_ASSET__BPvrREs9__"